<h4 class="mb-0">
  <span class="fa fa-long-arrow-right"></span>
  <span class="fa fa-desktop ml-1"></span>
  <span class="ml-2">{{ 'shared:download-connect.connectTo' | i18next: { format: 'title' } }}</span>
</h4>

<p class="mb-0 mb-4">{{ 'shared:download-connect.installRa' | i18next }} {{ 'shared:download-connect.connectTo' | i18next }}</p>

@for (build of builds$ | async; track build.mbsBuildType; let last = $last) {
  <section
    class="py-4"
    [ngClass]="{ 'border-bottom': !last }">
    <mbs-download-build
      [build]="build"
      [type]="type"
      [beta]="build.buildLabel === 'beta'"
      (raActionButtonClick)="configureButtonClick.emit(true)"
      [showDeleteButton]="false"></mbs-download-build>
  </section>
}

<ng-container *ngIf="!hideConnectFrom">
  <section class="border-top">
    <h4 class="mb-0 mt-4">
      <span class="fa fa-desktop"></span>
      <span class="fa fa-long-arrow-right ml-1"></span>
      <span class="ml-2">{{ 'shared:download-connect.connectFrom' | i18next: { format: 'title' } }}</span>
    </h4>

    <p>{{ 'shared:download-connect.installRa' | i18next }} {{ 'shared:download-connect.connectFrom' | i18next }}</p>
    <ul class="list-unstyled ml-3">
      <li class="mb-3">
        <a
          href="{{ getDownloadLink(connectFromBuilds$ | async, buildOsType.Windows) }}"
          target="_blank"
          [attr.data-e2e]="elementSelectors.name.windows">
          <span class="download-connect-icon ico ico-windows"></span>
          <span class="ml-3">{{ 'shared:download-connect.raClient.windows' | i18next }}</span>
        </a>
      </li>
      <li
        *ngFor="let platform of keys(raClientConfig)"
        class="mb-3">
        <a
          href="{{ environment.raDownloadURL[platform] }}"
          target="_blank"
          [attr.data-e2e]="elementSelectors.name[platform]">
          <span [class]="raClientConfig?.[platform]"></span>
          <span class="ml-3">{{ 'shared:download-connect.raClient.' + platform | i18next }}</span>
        </a>
      </li>
    </ul>
  </section>
</ng-container>
